import {EuropeDifficultyLevel} from "./types";

import {GAME_EUROPE} from "../../../Games";
import {Game} from "../../../types";
import {StringUtil} from "../../../../shared/string_util";
import {$KTS} from "../../../../shared/types";
import {MapGameFragment} from "../MapGameFragment";
import {ReactComponent as EuropeMap} from "../res/europe.svg";
import {Component} from "react";
import {Country, EUROPE_COUNTRIES} from "../types";

export class EuropeGameFragment extends MapGameFragment<EuropeDifficultyLevel> {

  protected getGame(): Game {
    return GAME_EUROPE;
  }

  protected allCountries(): Country[] {
    return EUROPE_COUNTRIES;
  }

  protected getMapComponent(): typeof Component {
    //@ts-ignore
    return EuropeMap;
  }

  protected getLevels(): EuropeDifficultyLevel[] {
    return EuropeDifficultyLevel.VALUES;
  }

  protected getResultText(): string {
    let resultText: string = "You completed %{level} game.";
    switch (this.state.gameConfig.level) {
      case EuropeDifficultyLevel.MEDIUM:
        resultText = StringUtil.format(resultText, $KTS("level", "a medium"));
        break;
    }
    return resultText;
  }
}